import React, { Component, Fragment } from 'react';
import { toast } from 'react-toastify';
import PastRandomSetsTable from '../components/randomSets/PastRandomSetsTable';
import SpinnerModal from '../components/common/SpinnerModal';
import RandomExportService from '../services/RandomExport/RandomExportService';

class RandomSets extends Component {
  _isMounted = false;
  randomExportService = new RandomExportService();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      randomSets: []
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchRandomSets();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async fetchRandomSets() {
    const randomSets = await this.randomExportService.getPastRandomExports();

    if (!randomSets) {
      toast.error('There was an error in fetching the exported random sets');
    }

    this._isMounted && this.setState({ isLoading: false, randomSets: randomSets || [] });
  }

  render() {
    const { isLoading, randomSets } = this.state;

    return (
      <Fragment>
        {isLoading && <SpinnerModal background={'bg-black opacity-50'} />}
        <div className="min-vh-75 min-vh-lg-100">
          <div className="mb-lg-4 mb-2 border-bottom border-400">
            <div className="pl-2">
              <div className="mb-lg-2 p-2">
                <div className="title random-sets-page-title pr-2 pt-2 pb-2">
                  <h1 className="h3">Random Sets</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="random-sets-page-content">
            <PastRandomSetsTable isLoading={isLoading} randomSets={randomSets} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default RandomSets;
